import logo from './logo.png'
import logoVisaMaster from './logo_visa_master.png'
import firecamp_background from './firecamp_background.jpeg'
import campfire from './campfire.svg'
import profile_placeholder from './profile_placeholder.png'
import default_female_avatar from './default_female_avatar.png'
import default_male_avatar from './default_male_avatar.png'
import default_female_profile from './default_female_profile.png'
import default_male_profile from './default_male_profile.png'

const backgrounds = {
    firecamp_background
}

export default {
    logo,
    logoVisaMaster,
    backgrounds,
    campfire,
    profile_placeholder,
    default_female_avatar,
    default_male_avatar,
    default_female_profile,
    default_male_profile
};